import React from 'react';

import BatteryStatus from './Status/Battery';
import TemperatureStatus from './Status/Temperature';
import PartialStatus from './Status/Partial';
import VisitsStatus from './Status/Visits';
import CanceledDeliveriesStatus from './Status/CanceledDeliveries';
import IssuesStatus from './Status/Issues';
import {inject, observer} from "mobx-react/index";
import VehicleHelper from './../helpers/Vehicle';

const StatusBar = ({document, style, show_speed, app_store}) => {
    const container_class_name = style.container_class_name || 'md-status-bar';
    const item_class_name = style.item_class_name || 'md-status-bar-item';

    const weight_occupation = document.weight_occupation;
    const vehicle = document.vehicle || {};
    const location = document.location || {};
    const temperature = document.temperature || {};
    const delivery_type = document.delivery_type || {};

    const vehicle_contract = vehicle.vehicle_contract || {};
    const vehicle_type = vehicle.vehicle_type || {};
    const location_payload = location.payload || {};
    const device = location_payload.device || {};
    const vehicle_device = document.vehicle_device || {};

    let ChangeSequenceIcon = null;
    let SpeedItem = null;

    const show_temperature = VehicleHelper.isCool(vehicle);

    if (vehicle.has_sequence_change) {
        ChangeSequenceIcon = (<div className={`${item_class_name}`}><i className="c-red material-icons">swap_horiz</i></div>);
    }

    if (show_speed) {
        SpeedItem = (<div className={item_class_name}>{Math.round(location.speed) || 0} km/h</div>);
    }

    return (
        <div className={container_class_name}>
            <div className={`${item_class_name}`}><i className="material-icons">directions_car</i> {vehicle.id} - {vehicle_contract.name} / {vehicle_type.name} ({weight_occupation}%)</div>
            <div className={`${item_class_name}`}><i className="material-icons">directions</i> {delivery_type.name}</div>

            {
                app_store.configurations.use_temperature && (
                    <TemperatureStatus show={show_temperature}
                                       goToReview={true}
                                       vehicleDevice={vehicle_device}
                                       temperature={temperature} />
                )
            }
            <BatteryStatus battery={device.battery} />

            <PartialStatus id={document.id} />

            <VisitsStatus id={document.id} />

            <CanceledDeliveriesStatus document={document} />
            <IssuesStatus  document={document} />

            {ChangeSequenceIcon}
            {SpeedItem}
        </div>
    );

}

StatusBar.defaultProps = {
    vehicle: {},
    style: {},
    show_speed: true
};

let container = observer(StatusBar);
container = inject(['app_store'])(container);

export default container;



// WEBPACK FOOTER //
// ./src/components/StatusBar.js